import useConfig from 'components/ConfigProvider/useConfig';
import { EMPTY_OBJECT, env } from 'constants';
import { AuthContext, CartContext } from 'constants/contexts';
import useFetchedData from 'hooks/useFetchedData';
// import useMockData from 'hooks/useMockData';
import React, { useContext, useMemo } from 'react';
import { priceTransformer } from 'utils';
import { getItemTotalPrice } from 'utils/item';

export default function useRewardsData(event) {
  const cart = useContext(CartContext);
  const subtotal = useMemo(() => cart.items.reduce((total, item) => total + getItemTotalPrice(item), 0), [cart.items]);
  const { user, isLoggedIn } = useContext(AuthContext);
  const disabled = useConfig('pwa.cateringRewardsDisabled') || (isLoggedIn && !user?.is_eligible_for_reward) || JSON.parse(env.CATERING_REWARD_DISABLED || 'false');

  const { data: userRewards } = useFetchedData(
    !disabled && isLoggedIn && event === RewardEvents.USER_TOTAL_REWARD && 'v1/integrations/rewards/user',
    ({ data } = EMPTY_OBJECT) => (data?.total_unredeemed_value ? priceTransformer(data.total_unredeemed_value) : undefined),
  );
  // const { data: userRewards } = useMockData({
  //   data: {
  //     total_unredeemed_value: 110,
  //   },
  // }, ({ data } = EMPTY_OBJECT) => (data.total_unredeemed_value));

  const { data: maxRewardRate } = useFetchedData(
    !disabled && cart.merchant && event === RewardEvents.MAX_REWARD_RATE && `v1/integrations/rewards/restaurants/${cart.merchant.id}/`,
    ({ data } = EMPTY_OBJECT) => data?.max_reward_rate,
  );

  // const { data: maxRewardRate } = useMockData({
  //   data: {
  //     max_reward_rate: 7.5,
  //   },
  // }, ({ data } = EMPTY_OBJECT) => data?.max_reward_rate);

  const { data: estimatedRewardMessage } = useFetchedData(
    !disabled && subtotal && user?.accepted_catering_rewards_terms && event === RewardEvents.ESTIMATED_REWARD_MESSAGE && `v1/integrations/rewards/estimate/?subtotal=${subtotal}&restaurant_id=${cart.merchant?.id}`,
    ({ data } = EMPTY_OBJECT) => (data ? (
      <span>
        You&apos;re earning
        {' '}
        {priceTransformer(data.total_value)}
        {' '}
        at
        {' '}
        {data.rate}
        % cashback
        {' '}
        {
          data.next_level_rate && (
            <>
              <br />
              Add
              {priceTransformer(data.gap_to_next_level)}
              {' '}
              to reach
              {' '}
              {data.next_level_rate}
              %
            </>
          )
        }
      </span>
    ) : ''),
  );

  // const { data: estimatedRewardMessage } = useMockData(
  //   {
  //     data: {
  //       base_points: 1650,
  //       bonus_points: 1000,
  //       total_value: 26.5,
  //       rate: '5',
  //       gap_to_next_level: 50,
  //       next_level_rate: '6',
  //       default_text: 'You will earn 1650 + 1000 points (~$26.5) in this order at 5%. Add $50 more to your cart to earn 6% cashback on this order.',
  //     },
  //   },
  //   ({ data } = EMPTY_OBJECT) => (data ? (
  //     <span>
  //       You&apos;re earning $
  //       {data.total_value}
  //       {' '}
  //       at
  //       {' '}
  //       {data.rate}
  //       % cashback
  //       {' '}
  //       <br />
  //       Add $
  //       {data.gap_to_next_level}
  //       {' '}
  //       to reach
  //       {' '}
  //       {data.next_level_rate}
  //       %
  //     </span>
  //   ) : ''),
  // );

  // return useMemo(() => ({}), []);
  switch (event) {
  case RewardEvents.USER_TOTAL_REWARD:
    return userRewards;
  case RewardEvents.MAX_REWARD_RATE:
    return maxRewardRate;
  case RewardEvents.ESTIMATED_REWARD_MESSAGE:
    return estimatedRewardMessage;
  default:
    return undefined;
  }
}

export const RewardEvents = {
  USER_TOTAL_REWARD: 'user_total_rewards',
  ESTIMATED_REWARD_MESSAGE: 'estimated_reward_message',
  MAX_REWARD_RATE: 'max_reward_rate',
};
